module.exports = __webpack_public_path__ + "img/imgs6.7cb44203.png";